// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientBlock_root__1gCGe","header":"PatientBlock_header__n1pyz","label":"PatientBlock_label__1hxBk","option":"PatientBlock_option__zRNWu"};